export default __webpack_public_path__ + "static/media/General_Clean.f3e4e7d1.jpg";